import { TCreateSavedConditionReqDto, TCreateSavedConditionResDto } from "@/api/services/main/saved-condition/dtos/create-saved-condition.dto";
import { clientApi } from "@/utils/api";
import { useMutation } from "@tanstack/react-query";

export const createSavedConditionApi = async (payload: TCreateSavedConditionReqDto): Promise<TCreateSavedConditionResDto> => {
  const { data } = await clientApi.post<TCreateSavedConditionResDto>("/saved-conditions", payload);
  return data;
};

export const useCreateSavedCondition = () => {
  return useMutation({
    mutationFn: createSavedConditionApi,
  });
};
